//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"AhpHeight",0,"Expression",0],[1,"AhpLength",0,"Expression",0],[1,"BofrpLength",0,"Expression",0],[1,"BofrpSwcLength",0,"Expression",0],[0,"EntityLayer",1,0],[0,"GridLineColorPicker",1,0],[0,"GridOffset",1,0],[0,"Loading",1,0],[0,"NoteColorPicker",1,0],[0,"NoteLayer",1,0],[0,"NoteOffsetX",1,0],[0,"NoteOffsetZ",1,0],[0,"Point95Offset",1,0],[0,"Population",1,0],[0,"ReferencePoint",1,"Point",0],[1,"RiseAngle",0,"Expression",0],[1,"SeatHeight",0,"Expression",0],[0,"SeatLineColorPicker",1,0],[0,"SgrpPoint",1,"Point",0],[1,"SgrpWidth",0,"Expression",0],[0,"Standard",1,0],[0,"TextSize",1,0],[0,"TransmissionType",1,0],[0,"UseStandardLoading",1,0],[0,"VehicleType",1,0]],[[[],"Legend",{},0,0],[[],"ReverseData",{},0,0],[[],"CreatePointWithBaseDataSGRPExpression",{R_:{sgrpPoint:"Point"}},0,0]],[]];
SPLM.Features.VehicleDesign.SeatLinesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.SeatLinesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.SeatLinesBuilder.StandardOption = Object.freeze({
    "SAEJ1516Oct2011" : "SAEJ1516Oct2011", "SAEJ4004Aug2008" : "SAEJ4004Aug2008"});

SPLM.Features.VehicleDesign.SeatLinesBuilder.VehicleOption = Object.freeze({
    "ClassAVehicleOnlyforstudy" : "ClassAVehicleOnlyforstudy", "ClassBVehicle" : "ClassBVehicle"});

SPLM.Features.VehicleDesign.SeatLinesBuilder.TransmissionOption = Object.freeze({
    "Manual" : "Manual", "Automatic" : "Automatic"});

SPLM.Features.VehicleDesign.SeatLinesBuilder.PopulationRatio = Object.freeze({
    "R5050" : "R5050", "R7525" : "R7525", "R9010to955" : "R9010to955"});

export default SPLM;